import { useMemo } from "react";

export default function useColumnsInvoices() {
 const columns = useMemo(
   () => [
     {
       Header: "ID",
       accessor: "_id"
     },
     {
       Header: "Fecha",
       accessor: "formatDate"
     },
     {
       Header: "Fecha",
       accessor: "date"
     },
     {
       Header: "N° de Comprobante",
       accessor: "invoiceNumber"
     },
     {
       Header: "Tipo de comprobante",
       accessor: "invoiceLetter"
     },
     {
       Header: "Importe",
       accessor: "price"
     }
   ],
   []
 );

 return columns;
}